require('async-section.coffee')
require('jquery-csrf.js')

jQuery(document).ready ($) ->
  new PT.Utils.Tooltip()
  PT.Utils.clipboard = new PT.Utils.Clipboard()

  $(".js-autofocus").focus()

  $(".toggle_hidden_searches a").click (e) ->
    e.preventDefault()
    $(this).parent().siblings(".hidden_searches").toggle()

  $("body").on "click", "button[data-confirm]", (e) ->
    e.preventDefault() if !confirm($(this).data("confirm"))

  $("[data-clickable-checkbox]").find("input[type=checkbox], a").on "click", (e) ->
    e.stopPropagation()

  $("[data-clickable-checkbox]").on "click", (e) ->
    $cb = $(this).find("input[type=checkbox]")
    $cb.trigger('click')

  $("button[data-trigger='final-warning']").on "click", (e) ->
    $(".cancel-confirm").addClass("mod-dim")

  # open external links in external windows
  $(document).on 'click', 'a[data-external]', (e) ->
    $(this).attr('target', '_blank')

  $("[data-async-section]").each ->
    new PT.AsyncSection(this)

  # on any form that has "data-disable-on-submit" attribute,
  # we want to disable the buttons to prevent double-submission
  $('form[data-disable-on-submit]').submit (e) ->
    $(this)
      .find('input.submit')
      .add('button.submit', $(this))
      .add('input[type=submit]', $(this))
      .add('button[type=submit]', $(this))
      .prop('disabled', true)

  # activate facebox
  $('a[rel=facebox]').facebox()

  # ajax links
  $('a[rel=ajax]').on "click", (e) ->
    e.preventDefault()
    $.loading("Loading...")
    $.get(this.href)

  # all forms wrapped in <div class="ajax">
  # should submit with ajax
  $('div.ajax form').submitWithAjax()

  $(document).on "click", "[data-feedback-button]", (e) ->
    $(this).data("original-html", $(this).html())
    $(this).html($(this).data("feedback-button"))

  # members list, toggling permissions (read-only vs full-access)
  $('ul#members select').on "change", ->
    $(this).parents('form').submit()

  # members list, toggling email updates (billing/usage)
  $('div.inline-list-form input[type=checkbox]').on "click", (e) ->
    $(this).parents('form').submit()

  $('ul#members form').on "submit", (e) ->
    e.preventDefault()
    $form = $(@)

    img = new Image()
    img.src = "/images/spinner.gif"

    $form.parents('span.options').append(img)

    $.post $form.attr('action'), $form.serialize(), ->
      $form.parents('span.options').find('img').remove()
      $(document).trigger('ajax:success', $form)

  $(document).on 'click', 'a.js-lineprof-file', (e) ->
    e.preventDefault()
    $(this).next('div').toggle()

  if $('#line-profile').length
    $.facebox({div: '#line-profile'}, 'full')

  $(document).on "click", "[data-flash-close]", (e) ->
    e.preventDefault()

    $(".flash").slideUp 100, -> $(".container").removeClass("mod-flash")


  ## document-level events

  $(document)

    # catch special key events
    .on 'keydown', (e) ->
      tagName = e.target.tagName
      return if (tagName == 'INPUT' or tagName == 'SELECT' or tagName == 'TEXTAREA')

      $(document).trigger 'keydown:shift' if e.shiftKey

    .on 'keyup', (e) ->
      tagName = e.target.tagName
      return if (tagName == 'INPUT' or tagName == 'SELECT' or tagName == 'TEXTAREA')

      # using which because shiftKey only works when it's pressed
      # jQuery normalizes this event http://api.jquery.com/event.which/
      $(document).trigger 'keyup:shift' if e.which is 16

    # Relies on the Page Visibility API
    # -> https://developer.mozilla.org/en-US/docs/Web/API/Page_Visibility_API
    .on 'visibilitychange', ->
      if document.hidden
        $(document).trigger 'document:hidden'
      else
        $(document).trigger 'document:visible'
